const OPENED = "open";
const EVALUATOR_FILLING = "complete_evaluator";
const FILL_TEAM = "complete_staff";
const EXPIRED = "close";

export {
    OPENED,
    EVALUATOR_FILLING,
    FILL_TEAM,
    EXPIRED
}
